/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RightDto } from './RightDto';
import {
    RightDtoFromJSON,
    RightDtoFromJSONTyped,
    RightDtoToJSON,
    RightDtoToJSONTyped,
} from './RightDto';

/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * Role ID
     * @type {string}
     * @memberof RoleDto
     */
    id: string;
    /**
     * Role name
     * @type {string}
     * @memberof RoleDto
     */
    name: string;
    /**
     * Role description
     * @type {string}
     * @memberof RoleDto
     */
    description: string;
    /**
     * Role rights
     * @type {Array<RightDto>}
     * @memberof RoleDto
     */
    rights: Array<RightDto>;
    /**
     * Role providers
     * @type {Array<string>}
     * @memberof RoleDto
     */
    providers: Array<string>;
    /**
     * Role created on
     * @type {Date}
     * @memberof RoleDto
     */
    createdOn: Date;
    /**
     * Role updated on
     * @type {Date}
     * @memberof RoleDto
     */
    updatedOn: Date;
}

/**
 * Check if a given object implements the RoleDto interface.
 */
export function instanceOfRoleDto(value: object): value is RoleDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('rights' in value) || value['rights'] === undefined) return false;
    if (!('providers' in value) || value['providers'] === undefined) return false;
    if (!('createdOn' in value) || value['createdOn'] === undefined) return false;
    if (!('updatedOn' in value) || value['updatedOn'] === undefined) return false;
    return true;
}

export function RoleDtoFromJSON(json: any): RoleDto {
    return RoleDtoFromJSONTyped(json, false);
}

export function RoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'rights': ((json['rights'] as Array<any>).map(RightDtoFromJSON)),
        'providers': json['providers'],
        'createdOn': (new Date(json['createdOn'])),
        'updatedOn': (new Date(json['updatedOn'])),
    };
}

export function RoleDtoToJSON(json: any): RoleDto {
    return RoleDtoToJSONTyped(json, false);
}

export function RoleDtoToJSONTyped(value?: RoleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'rights': ((value['rights'] as Array<any>).map(RightDtoToJSON)),
        'providers': value['providers'],
        'createdOn': ((value['createdOn']).toISOString()),
        'updatedOn': ((value['updatedOn']).toISOString()),
    };
}

